module.exports = __webpack_public_path__ + "img/更换.dc8a8920.png";